import { Grid } from '@mui/material';
import { FormNotasUsuario, ListaNotasUsuario } from '../../components/notasUsuarios';

export const NotasUsuario = () => (
  <Grid sx={{ marginTop: 1 }} container spacing={2}>
    <FormNotasUsuario />
    <ListaNotasUsuario />
  </Grid>
);
